import React, { MutableRefObject, useCallback, useRef, useState } from 'react';
import { IconDots } from '@tabler/icons-react';
import { useOffClick } from '../../../Common/Common.hooks';
import classNames from 'classnames';
import { Popper, Tooltip } from '@mui/material';
import { ControlItemType } from '../InteractiveModeControls/InteractiveModeControls';
import { FLO_PAGE_VIDEO_MORE } from '../../../Common/Common.constants';
import { preventDefaultForTouchEndEvent } from '../../../Common/Common.utils';
import styles from './MobileViewControlOptions.module.css';

const MobileViewControlOptions = ({
	onOptionClick,
	options,
	classes,
	tooltipPosition,
	tooltipParent,
}: {
	onOptionClick(item: ControlItemType, event: React.MouseEvent | React.TouchEvent): void;
	options: ControlItemType[];
	tooltipPosition: 'bottom' | 'top';
	classes?: { optionsWrapper: string };
	tooltipParent: HTMLElement | undefined | null;
}) => {
	const ref = useRef<HTMLDivElement | undefined>(
		undefined
	) as MutableRefObject<HTMLDivElement>;

	const [showOptions, setShowOptions] = useState(false);
	useOffClick(() => {
		setShowOptions(false);
	}, ref);

	const toggleOptions = useCallback(
		(event: React.MouseEvent | React.TouchEvent) => {
			preventDefaultForTouchEndEvent(event);
			setShowOptions((curVal) => !curVal);
		},
		[setShowOptions]
	);

	return (
		<div className={classNames(styles.optionsWrapper, classes?.optionsWrapper || '')}>
			<div
				className={styles.optionsIconWrapper}
				onTouchEnd={toggleOptions}
				onClick={toggleOptions}
				// @ts-ignore
				ref={ref}
			>
				<Tooltip
					PopperProps={{
						container: tooltipParent,
					}}
					classes={{
						popper: styles.popOver,
					}}
					arrow
					title={showOptions ? '' : FLO_PAGE_VIDEO_MORE}
					placement={tooltipPosition}
				>
					<div className={styles.optionsIcon}>
						<IconDots
							size={18}
							className={classNames(styles.dotsIcon, {
								[styles.dotsIconActive]: showOptions,
							})}
						/>
					</div>
				</Tooltip>
			</div>
			{showOptions && (
				<Popper
					open={Boolean(ref.current)}
					container={tooltipParent}
					anchorEl={ref.current}
					className={classNames(styles.popOver)}
					placement={`${tooltipPosition}-end`}
				>
					<ul
						className={styles.optionsList}
						onTouchEnd={(e: React.TouchEvent) => {
							e.stopPropagation();
							e.preventDefault();
						}}
					>
						{options.map((item) => {
							const { label, name, icon: Icon } = item;
							return (
								<li
									className={styles.optionsListItem}
									onTouchEnd={(event: React.TouchEvent) => {
										preventDefaultForTouchEndEvent(event);
										setShowOptions(false);
										onOptionClick(item, event);
									}}
									onClick={(event: React.MouseEvent) => {
										setShowOptions(false);
										onOptionClick(item, event);
									}}
									key={`${label}-${name}`}
								>
									<div className={styles.listItemIconWrapper}>
										{/*@ts-ignore*/}
										<Icon size={16} className={styles.optionsListItemIcon} />
									</div>
									<div className={styles.optionsListItemLabel}>{label}</div>
								</li>
							);
						})}
					</ul>
				</Popper>
			)}
		</div>
	);
};

export default MobileViewControlOptions;
